import React from 'react';
import { FaUsers, FaClipboardCheck } from 'react-icons/fa';
import {
  ConnectedToolsSection,
  SectionHeading,
  ConnectedTools,
  ConnectedToolLink,
  ConnectedToolIcon,
} from './Connected.styles';

const Connected = () => {
  return (
    <ConnectedToolsSection>
      <SectionHeading>
        <p className="eyebrowHeader">Connected Safety Tools</p>

        <h2>Bring More of Your Safety Program Online</h2>

        <p>
          Safety manuals can work alongside company training and digital safety
          forms to help keep important workplace information more organized.
        </p>
      </SectionHeading>

      <ConnectedTools>
        <ConnectedToolLink to="/company-training">
          <ConnectedToolIcon>
            <FaUsers />
          </ConnectedToolIcon>

          <div>
            <span>Company Training</span>

            <h3>Manage Employee Safety Training</h3>

            <p>
              Assign courses, track completion, and keep employee training
              records and certificates easier to access.
            </p>

            <strong>
              Explore Company Training
              <span aria-hidden="true">→</span>
            </strong>
          </div>
        </ConnectedToolLink>

        <ConnectedToolLink to="/digital-safety-forms">
          <ConnectedToolIcon>
            <FaClipboardCheck />
          </ConnectedToolIcon>

          <div>
            <span>Digital Safety Forms</span>

            <h3>Turn Existing PDFs Into Digital Forms</h3>

            <p>
              Give employees forms they can complete online while keeping
              submitted records easier to view, filter, and query.
            </p>

            <strong>
              Explore Digital Forms
              <span aria-hidden="true">→</span>
            </strong>
          </div>
        </ConnectedToolLink>
      </ConnectedTools>
    </ConnectedToolsSection>
  );
};

export default Connected;
